import React from "react";
import "../../styles/introduction.css";
import gilcaImg from "../../img/gilca/Gilca_img.png";
import { motion } from "framer-motion";

const Introduction: React.FC = () => {
  return (
    <div className="container-introduction">
      <div className="teste_zoom">
        <div className="introduction_gilca">
          {/* Texto com animação */}
          <div className="home-body-content">
            <motion.h2
              className="clinica_especialidades_gilca"
              initial={{ x: -50, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              transition={{ duration: 1, ease: "easeOut" }}
              viewport={{ once: true, amount: 0.5 }}
            >
              Cuidado, Experiência e Dedicação em Terapias no Rio Grande do Sul
            </motion.h2>

            <motion.p
              className="clinica_texto"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 1.5, ease: "easeOut", delay: 0.3 }}
              viewport={{ once: true, amount: 0.5 }}
            >
              Gilca Lucena possui uma formação acadêmica sólida e diversificada, com doutorado e mestrado em educação, além de especializações em áreas como neuropsicologia e terapia de casal e família. Sua expertise se destaca na estimulação precoce para bebês com patologias, bem como no atendimento a crianças e adolescentes com transtornos do desenvolvimento e dificuldades de aprendizagem.
              <br />
              <br />
              Sempre em busca de aprimoramento contínuo, Gilca integra o Grupo de Formação Avançada em Terapia Comportamental ABA no Autismo para Terapeutas, reforçando seu compromisso com a atualização profissional e a excelência no atendimento.
            </motion.p>
          </div>

          {/* Imagem com animação */}
          <motion.div
            className="introduction_image"
            initial={{ y: -50, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 1.2, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.4 }}
          >
            <img className="img_gilca" src={gilcaImg} alt="Gilca Lucena" />
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Introduction;
